import { OverlayColor } from './colors.enum';

export type Overlay = Rectangle | Circle | Triangle | Image | Counter | Text;

type Base = {
  x: number;
  y: number;
  fillColor?: OverlayColor;
  transparency?: number;
  image?: string;
  value?: number;
};

export type Rectangle = Base & {
  type: 'rectangle';
  width: number;
  height: number;
};

export type Circle = Base & {
  type: 'circle';
  radius: number;
};

export type Triangle = Base & {
  type: 'triangle';
  size: number;
  angle: number;
  direction: 'cw' | 'ccw';
};

export type Image = Base & {
  type: 'image';
  image: string;
  scale?: number;
};

export type Counter = Base & {
  type: 'counter';
  radius: number;
};

export type Text = Base & {
  type: 'text';
  text: string;
  fontSize?: number;
};

export type Canvas = 'static' | 'dynamic';
